import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
import about3 from "../../../assets/images/about/about-3.jpg"
import team01 from "../../../assets/images/team/team-01.jpg"

const CommercialList = [
    "Free Cost Estimate",
    "Top-Rated Service",
    "Professional Packing of your Equipment and Office Furniture",
    "Loading the packages in our moving trucks and transport it to your new location",
    "Unpacking your equipment and setting it up in your new place",
    "Inventory lists for relocation management",
    "Hassle-free move without disturbing your business",
    "Certified team of professional movers, Licensed & Insured for Commercial Moving"
];
const ChooseList = [
    "Free Cost Estimation",
    "We offer flex payment for larger moves",
    "Floor, Carpet and Wall protection",
    "Trusted, reliable and efficient staff",
    "All our staff are covered by worksafeBC",
    "We take extra care of your sensitive equipment like computers, LCDs, and other machinery",
    "Assembling and disassembling of your furniture like office tables",
    "Secure, Reliable, Certified, and Insured Company",
    "Not only we move your stuff to a new location but also help in setting up your equipment there"
];

class Commercial extends Component{    
    render(){
        
        let title = 'Commercial';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Commercial' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                {/* <div className="rn-page-title-area pt--200 pb--200 bg_image bg_image--17 background-img-commercial mt--90"/> */}
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src={about3} alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                        <Breadcrumb title={'Commercial'} />
                                            <h2 className="title">{title}</h2>
                                            <p className="description">When you have a business to run where you have to please your clients and manage your employees then the last thing you need to worry about is your office move.<a href="/"> Moonline </a> understands all your needs and we always strive to provide you with peace of mind when you are planning your office move. Moving an office requires much more effort and planning as compared to the residential move. </p>
                                            <p className="description">Offices contain materials and equipment like cubicles, desks, copy machines, computers, and more that are difficult to pack and move from one place to another. You may also have to limit some of your business operations during your move which can make you lose a little bit of office revenue also.</p>
                                            <p className="description">At <a href="/">Moonline</a>, we believe that moving and relocating your business shouldn’t be difficult. It should be simple and efficient so that you don’t lose any revenue during your move. Therefore, we offer full-scale office and commercial moving services in Greater Vancouver, Victoria and Vancouver Island. We have a professional staff having years of experience in moving the office equipment and we will make your office move easy and stress-free.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-7 pt--100">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title" style={{lineHeight:1.4}}>Moving Service For Business Of Every Size</h3>
                                            <p className="description">No matter what’s the size of your company or what’s your budget for the move, Moonline have customized packages to meet all your moving needs. We are experienced in moving small to medium and large-sized businesses. It doesn’t matter from which industry do you belong we have worked in all industries from retail and services to industrial and medical offices. So if you want to make your office move smooth and effortless then Moonline is the right choice for you.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 pt--100">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title" style={{lineHeight:1.4}}>What Do We Offer In Our Commercial Moving Services?</h3>
                                            <p className="description">Want to know how we work and what do we provide in our packages? We offer the best and quality services to our commercial moving clients. When you work with us you‘ll get:</p>
                                            <ol style={{paddingLeft:'3vh'}}>
                                                {CommercialList.map(List => <li style={{lineHeight:2,fontSize:'20px'}}>{List}</li>)}
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8 pt--100" >
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h3 className="title" style={{lineHeight:1.4}}>Why Choose Us?</h3>
                                            <p className="description">Are you curious why should you choose us over many other moving companies? Here are some of the reasons that make our company stand out.</p>
                                            <ol style={{paddingLeft:'3vh'}}>
                                                {ChooseList.map(List => <li style={{lineHeight:2,fontSize:'20px'}}>{List}</li>)}
                                            </ol>
                                            <p>So if you searching for a moving company near you then look no further because <a href="/">Moonline</a> got you covered. We offer our services at the most affordable prices. So pick up your phone and get a free estimate for your commercial move from our experts. You can also contact us through our website to pre-book your move to ensure our availability on your desired date.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team01} alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team01} alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src={team01} alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Commercial;